import { render, staticRenderFns } from "./TouchReservation.vue?vue&type=template&id=26cb9ace&scoped=true&"
import script from "./TouchReservation.vue?vue&type=script&lang=js&"
export * from "./TouchReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb9ace",
  null
  
)

export default component.exports